import { createGetEndpoint } from '@sonar-software/sonar-http';
import { SalesforceUser } from '@types';

export const getAllSalesforceUsers = createGetEndpoint<void, SalesforceUser[]>(() => '/api/v3/salesforce/sfUsers');
